export const LOCATION_KEY = 'ngp-auth:location'
export const TOKEN_KEY = 'ngp-auth:token'
export const RECOVERY_KEY = 'ngp-auth:recover'
export const SILENT_LOGIN_IFRAME_ID = 'silent-login'
